"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRealBlockchainSpecified = exports.isBlockchainSpecified = void 0;
var blockchains = ["ETHEREUM", "FLOW", "TEZOS", "SOLANA", "APTOS"];
var realBlockchains = [
    "ETHEREUM",
    "FLOW",
    "TEZOS",
    "POLYGON",
    "SOLANA",
    "ECLIPSE",
    "IMMUTABLEX",
    "MANTLE",
    "ARBITRUM",
    "ZKSYNC",
    "CHILIZ",
    "LIGHTLINK",
    "RARI",
    "ASTARZKEVM",
    "BASE",
    "FIEF",
    "XAI",
    "KROMA",
    "CELO",
    "APTOS",
    "SEI",
    "SAAKURU",
    "OASYS",
    "MOONBEAM",
    "PALM",
    "ETHERLINK",
    "LISK",
    "ALEPHZERO",
];
function isBlockchainSpecified(value) {
    for (var _i = 0, blockchains_1 = blockchains; _i < blockchains_1.length; _i++) {
        var blockchain = blockchains_1[_i];
        if (value.startsWith(blockchain + ":")) {
            return true;
        }
    }
    return false;
}
exports.isBlockchainSpecified = isBlockchainSpecified;
function isRealBlockchainSpecified(value) {
    for (var _i = 0, realBlockchains_1 = realBlockchains; _i < realBlockchains_1.length; _i++) {
        var blockchain = realBlockchains_1[_i];
        if (value.startsWith(blockchain + ":")) {
            return true;
        }
    }
    return false;
}
exports.isRealBlockchainSpecified = isRealBlockchainSpecified;
